import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const [quote, setQuote] = useState('');

  // Array of anime quotes related to being lost or not finding something
  const animeQuotes = [
    "Not all those who wander are lost, but you definitely are.",
    "Your page may be gone, but your anime journey continues!",
    "Even Zoro from One Piece wouldn't get this lost.",
    "This page has disappeared faster than ninjas in Naruto.",
    "Looks like this page went to the Shadow Realm.",
    "This page is more elusive than a legendary Pokémon.",
    "The page you're looking for has gone beyond Plus Ultra!",
    "You thought it was a valid page, but it was me, 404!",
    "This page has gone on a training arc and will return stronger.",
    "Even the Dragon Balls can't summon this page."
  ];

  useEffect(() => {
    // Select random quote
    const randomIndex = Math.floor(Math.random() * animeQuotes.length);
    setQuote(animeQuotes[randomIndex]);
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1>404</h1>
        <div className="character">
          <div className="character-face">
            <div className="eyes"></div>
            <div className="mouth"></div>
          </div>
        </div>
        <h2>Page Not Found</h2>
        <p className="quote">{quote}</p>
        <p className="subtitle">The page you're looking for doesn't exist or has been moved.</p>
        <div className="not-found-actions">
          <button className="back-button" onClick={goBack}>
            Go Back
          </button>
          <Link to="/" className="home-button">
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;